<template>
    <div class="min-h-11 grow flex overflow-hidden bg-purple-60 dark:bg-black-370 border border-gray-100 dark:border-gray-730 focus-within:border-primary dark:focus-within:border-primary rounded-5 transition-colors">
        <textarea
            ref="inputRef"
            v-model="prompt"
            class="w-full bg-transparent text-xs px-4 py-[13px] min-h-4 max-h-40 text-gray-370 dark:text-white placeholder:text-gray-280 dark:placeholder:text-gray-200 resize-none custom-scroll-y"
            placeholder="Ask a question..."
            rows="1"
            @keydown.enter.exact.prevent="send"
            @keydown.enter.shift.exact="addLine"
            @input="autoResize"
        ></textarea>
    </div>
</template>

<script setup>
import { nextTick, useTemplateRef, watch } from 'vue'

import { useAppStore } from '@/store/appStore'

const props = defineProps({
    isStreaming: {
        type: Boolean,
        default: false,
    },
})

const emits = defineEmits(['send', 'scrollToBottom'])

const prompt = defineModel('prompt', { type: String, default: '' })

const appStore = useAppStore()

const inputRef = useTemplateRef('inputRef')

function addLine() {
    prompt.value += '\n'
}

async function autoResize() {
    await nextTick()

    const el = inputRef.value

    if (!el) {
        return
    }

    el.style.height = 'auto'
    el.style.height = `${Math.min(el.scrollHeight, 180)}px`
}

async function send() {
    if (props.isStreaming) {
        return
    }

    emits('send')
    scrollToBottom()
}

function scrollToBottom() {
    emits('scrollToBottom')
}

watch(prompt, () => {
    autoResize()
})

watch(() => appStore.currentAiAgentView, () => {
    autoResize()
}, { immediate: true })
</script>
